<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <div class="row pd-t50 exhibitor-backoffice-sub-header" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
      <div class="col-lg-4">
        <h1>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.TITLE' | translate }}</h1>
      </div>
    </div>

    <div class="exhibitor-backoffice__content" *ngIf="loader.count === 0">
      <div class="filter-button-container">
        <div class="form-group form-group--filter">
          <input type="text" class="form-control" [(ngModel)]="filter" name="filter" placeholder="{{ 'COMMON.SEARCH' | translate }}" #ffilter="ngModel">
        </div>
        <div class="mb-5">          
          <button type="button" *ngIf="rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])" (click)="createExhibitor()" class="btn btn--primary float-end mr-md-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.CREATE_EXHIBITOR' | translate }}</button>
          <button type="button" *ngIf="rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])" (click)="publishAllExhibitorsBtn()" class="btn btn--light float-end mr-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.PUBLISH_ALL' | translate }}</button>
          <button type="button" *ngIf="rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])" (click)="unpublishAllExhibitorsBtn()" class="btn btn--light float-end mr-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.UNPUBLISH_ALL' | translate }}</button>
        </div>
      </div>
      <div class="table__wrapper">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col" style="width: 40%">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.COL_NAME' | translate }}</th>
              <th scope="col" style="width: 30%" *ngIf="!rolesService.isSingleExhibitor() && !rolesService.isMultipleExhibitor()">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.COL_STATUS' | translate }}</th>
              <th scope="col" style="width: 15%" *ngIf="rolesService.isSingleExhibitor() || rolesService.isMultipleExhibitor()">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.COL_STAND' | translate }}</th>
              <th scope="col" style="width: 15%" *ngIf="rolesService.isSingleExhibitor() || rolesService.isMultipleExhibitor()">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.COL_SECTOR' | translate }}</th>
              <th scope="col" style="width: 10%">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.COL_PRODUCTS' | translate }}</th>
              <th scope="col" style="width: 10%">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.COL_VISIBLE' | translate }}</th>
              <th scope="col" style="width: 10%">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.COL_PUBLISHED' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let exhibitor of filterElements() | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize" (click)="goTo(exhibitor)">
              <td *ngIf="exhibitor.name.length > 80">{{ exhibitor.name.substring(0, 80) }}...</td>
              <td *ngIf="exhibitor.name.length <= 80">{{ exhibitor.name }}</td>
              <td *ngIf="!rolesService.isSingleExhibitor() && !rolesService.isMultipleExhibitor()">{{ utilsService._api(getStatusObject(exhibitor.statusId).translations, 'translation') }}</td>
              <td *ngIf="rolesService.isSingleExhibitor() || rolesService.isMultipleExhibitor()"><app-stand-display [standData]="exhibitor.standLocation"></app-stand-display></td>
              <td *ngIf="rolesService.isSingleExhibitor() || rolesService.isMultipleExhibitor()">{{ utilsService._api(exhibitor.sector?.translations, 'name') }}</td>
              <td *ngIf="!rolesService.isSingleExhibitor() && !rolesService.isMultipleExhibitor()">{{ exhibitor.statistics.productCount }}</td>
              <td *ngIf="rolesService.isSingleExhibitor() || rolesService.isMultipleExhibitor()">{{ exhibitor.productCount }}</td>
              <td>{{ 'COMMON.' + exhibitor.visible.toString().toUpperCase() | translate }}</td>
              <td>{{ 'COMMON.' + exhibitor.published.toString().toUpperCase() | translate }}</td>
            </tr>
            <tr *ngIf="filterElements().length < 1">
              <td colspan="5">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.NO_EXHIBITORS' | translate }}</td>
            </tr>
          </tbody>
        </table>
        <ngb-pagination class="d-flex justify-content-end" [(page)]="page" [pageSize]="pageSize"
                        [collectionSize]="filterElements().length" [maxSize]="10"></ngb-pagination>
      </div>
    </div>

  </div>
</div>

<app-footer></app-footer>
